/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Waiting_RechecksInputs */



/**
* | output |
* | --- |
* | "This page checks again by itself every few minutes." |
*
* @param {Org_Waiting_RechecksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_waiting_rechecks = /** @type {((inputs?: Org_Waiting_RechecksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Waiting_RechecksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Seite prüft alle paar Minuten automatisch erneut.")
	return /** @type {LocalizedString} */ ("This page checks again by itself every few minutes.")
});